import { ACCESS, SERVICES } from "../../../../configs/constants";
import { Button, Dropdown, Icon, Menu } from "antd";
import AuthRender from "../../../../containers/AuthRender";
import React from "react";
import { connect } from "react-redux";
import { mailNbVisitsPerDay, mailNbVisitsPerDayLucca } from "../../actions/stats";
import moment from "moment-timezone";
import { getTableLoading } from "../../selectors";

import { currentClientSelector } from "../../../../redux/selectors/auth";
import { isStartDateRef } from "../../utils";

let DIMENSION_INFOS = {};
const setDimensionInfos = (clientInfos = {}) => {
  let pdc_label = [{ id: "pdc_id", label: "PDC ID" }];
  let pdc_id = [
    {
      id: "pdc_label",
      label: "PDC"
    }
  ];
  if (clientInfos.id === 17) {
    pdc_label.push({ id: "pdc_cip", label: "PDC CIP" });
    pdc_id.push({ id: "pdc_cip", label: "PDC CIP" });
  }

  DIMENSION_INFOS = {
    pdc_label,
    pdc_id,
    product_ean: [{ id: "product_ean", label: "EAN" }],
    retailer_label: [{ id: "retailer_id", label: "RETAILER ID" }]
  };
};

const getDimensions = (
  dataset,
  dimensions,
  level = 0,
  currentLevel = 0,
  currentDimensions = [],
  dimensionInfos = []
) => {
  if (currentLevel > level) return [];

  if (level === currentLevel) {
    const line = [];
    for (let i = 0; i < dimensions.length; i++) {
      const dimension = dimensions[i] || "";

      //add additional infos
      const infos = DIMENSION_INFOS[dimension] || [];
      for (let j = 0; j < infos.length; j++) {
        const info = infos[j] || {};
        if (currentDimensions[i]) {
          line.push(dimensionInfos[info.id]);
        } else {
          line.push("");
        }
      }

      if (currentDimensions[i]) {
        const currentDimension = currentDimensions[i];
        line.push(currentDimension);
      } else {
        line.push("Total");
      }
    }

    if (dataset.format === "%") {
      line.push(dataset.value / 100);
    } else {
      line.push(dataset.value);
    }

    if (dataset.format === "%" || dataset.format === "/" || dataset.format === "weight") {
      line.push(dataset.v === null ? "" : dataset.v);
      line.push(dataset.n === null ? "" : dataset.n);
    }

    if (dataset.p1) {
      if (dataset.p1.format === "%") {
        line.push(dataset.p1.value / 100);
      } else {
        line.push(dataset.p1.value);
      }

      if (dataset.p1.format === "%" || dataset.p1.format === "/" || dataset.p1.format === "weight") {
        line.push(dataset.p1.v === null ? "" : dataset.p1.v);
        line.push(dataset.p1.n === null ? "" : dataset.p1.n);
      }
    }
    if (dataset.diff) {
      if (dataset.format === "%") {
        line.push(dataset.diff.value / 100);
      } else {
        line.push(dataset.diff.value);
      }
    }

    return [line];
  }

  const data = dataset.data;
  if (data && data.length > 0) {
    const dims = [];
    for (let i = 0; i < data.length; i++) {
      const datum = data[i];
      const dimInfos = datum.dim_infos || {};
      dimensionInfos = { ...dimensionInfos, ...dimInfos };
      const dimensionLabel = datum.dim_value || "Non renseigné";
      const dimData = getDimensions(
        datum,
        dimensions,
        level,
        currentLevel + 1,
        [...currentDimensions, dimensionLabel],
        dimensionInfos
      );
      if (dimData) {
        for (let j = 0; j < dimData.length; j++) {
          const dimDatum = dimData[j];
          dims.push(dimDatum);
        }
      }
    }

    if (dims.length > 0 && currentLevel > 0 && currentLevel === level - 1) {
      const line = [];
      //add sub total
      for (let i = 0; i < dimensions.length; i++) {
        const dimension = dimensions[i];
        //add additional infos
        const infos = DIMENSION_INFOS[dimension] || [];
        for (let j = 0; j < infos.length; j++) {
          const info = infos[j] || {};
          if (currentDimensions[i]) {
            line.push(dimensionInfos[info.id]);
          } else {
            line.push("");
          }
        }

        if (currentDimensions[i]) {
          line.push(currentDimensions[i]);
        } else {
          line.push("Total");
        }
      }

      if (dataset.format === "%") {
        line.push(dataset.value / 100);
      } else {
        line.push(dataset.value);
      }

      if (dataset.format === "%" || dataset.format === "/" || dataset.format === "weight") {
        line.push(dataset.v === null ? "" : dataset.v);
        line.push(dataset.n === null ? "" : dataset.n);
      }

      if (dataset.p1) {
        if (dataset.p1.format === "%") {
          line.push(dataset.p1.value / 100);
        } else {
          line.push(dataset.p1.value);
        }

        if (dataset.p1.format === "%" || dataset.p1.format === "/" || dataset.p1.format === "weight") {
          line.push(dataset.p1.v === null ? "" : dataset.p1.v);
          line.push(dataset.p1.n === null ? "" : dataset.p1.n);
        }
      }
      if (dataset.diff) {
        if (dataset.format === "%") {
          line.push(dataset.diff.value / 100);
        } else {
          line.push(dataset.diff.value);
        }
      }
      dims.unshift(line);
      dims.unshift([]);
    }

    return dims;
  }
  return [];
};
const periodToTitle = (period = []) => {
  const startDate = moment(period[0]) || moment();
  const endDate = moment(period[1]) || moment();

  if (isStartDateRef(startDate)) {
    return `${endDate.format("DD/MM/YYYY")}`;
  } else {
    return `Période du ${startDate.format("DD/MM/YYYY") || ""} au ${endDate.format("DD/MM/YYYY") || ""}`;
  }
};
const ExtraStats = ({ tableLoading, currentClient, mailNbVisitsPerDay, mailNbVisitsPerDayLucca, style, period }) => {
  if (tableLoading) return null;
  setDimensionInfos(currentClient);
  const propsStyle = style || {};
  const trimmedPeriod = trimPeriod(period);
  return (
    <AuthRender service={SERVICES.Statistiques} access={ACCESS.export}>
      <Dropdown
        overlay={
          <Menu
            onClick={({ key }) => {
              if (key === "nbvisitperdaylucca") {
                mailNbVisitsPerDayLucca(trimmedPeriod);
              }
            }}
          >
            <Menu.Item key="nbvisitperdaylucca">
              <Icon type="mail" />{" "}
              {`Envoi mail nombre de visites par jour avec présence LUCCA (${periodToTitle(
                trimmedPeriod
              )}) (ATTENTION : période réduite à 4 mois si la période sélectionnée est supérieure à 4 mois)`}
            </Menu.Item>
          </Menu>
        }
      >
        <Button style={{ color: "white", float: "right", ...propsStyle }} type="primary" size={"default"}>
          Extra stats visites
        </Button>
      </Dropdown>
    </AuthRender>
  );
};

const trimPeriod = period => {
  // if period is greater than 4 months, trim it to 4 months
  const startDate = moment(period[0]) || moment();
  const endDate = moment(period[1]) || moment();
  const diff = endDate.diff(startDate, "months");
  if (diff > 4) {
    return [
      endDate
        .clone()
        .subtract(4, "months")
        .format("YYYY-MM-DD"),
      endDate.format("YYYY-MM-DD")
    ];
  }
  return period;
};

const mapStateToProps = state => {
  const stats = state.stats || {};
  return {
    tableLoading: getTableLoading(state),
    period: stats.period || [],
    currentClient: currentClientSelector(state)
  };
};

export default connect(mapStateToProps, {
  mailNbVisitsPerDay,
  mailNbVisitsPerDayLucca
})(ExtraStats);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/ExtraStats.js